import request from "/utils/request";

export default () => request
  .get("/api/me")
  .then(config => {
    if (config) {
      return config;
    } else {
      throw new Error("No config data found in /me response");
    }
  });
